module.exports = require("./ccp-IN.d.ts");